import { DiscussionEmbed } from 'disqus-react'
import { useEffect } from 'react'

import { useTheme } from '@/components/ThemeProvider/ThemeProvider'

type Props = {
  identifier?: string
  slug: string
  title: string
}

const Disqus = ({ identifier, slug, title }: Props) => {
  const theme = useTheme()

  useEffect(() => {}, [theme])

  if (!identifier) return null

  return (
    <DiscussionEmbed
      config={{
        identifier,
        title,
        url: `https://edhrec.com/articles/${slug}`,
      }}
      shortname='edhrec'
    />
  )
}

export default Disqus
